<a class="pc-pet" [routerLink]="['/pet', pet.id]">

  <span class="pc-foto" [class.b]="indice % 2 === 1">
    <img *ngIf="pet.pictureUrl" [src]="pet.pictureUrl" [alt]="pet.name">
    <ng-container *ngIf="!pet.pictureUrl">{{ inicial }}</ng-container>
  </span>

  <h3>{{ pet.name }}</h3>

  <div class="pc-datos">{{ datosLinea }}</div>

  <!-- Proxima vacuna real (API de Vet). Sin recordatorios no se muestra tag. -->
  <span class="pc-tag" *ngIf="proximaVacuna">
    {{ proximaVacuna.descripcion }} el {{ proximaVacuna.fecha | date:'d \'de\' MMMM':'':'es-AR' }}
  </span>

  <div class="pc-go">{{ textoAccion }}</div>

</a>
